import type { ComponentType, ReactNode } from 'react';
import { DownOutlined } from '@ant-design/icons';
import type { ButtonProps } from 'antd';
import cx from 'classnames';
import { AntdTypography, Button } from '@ui/components';

const { Text } = AntdTypography;

// Rendered as a child rather than through antd's own `icon` slot, which brings its own spacing.
interface NavBarDropdownTriggerProps extends Omit<ButtonProps, 'icon'> {
  icon: ComponentType<{ className?: string }>;
  label: ReactNode;
}

// Plain prop-spreading component on purpose: AntdDropdown clones its child to inject the
// trigger handlers, so everything it passes has to reach the Button.
export const NavBarDropdownTrigger = ({
  className,
  icon: Icon,
  label,
  ...rest
}: NavBarDropdownTriggerProps) => (
  <Button
    type="text"
    className={cx('!text-primary-600 flex items-center gap-2 px-1 py-0', className)}
    {...rest}
  >
    <Icon className="text-sm mt-[3px]" />
    <Text className="hidden lg:block !text-primary-600">{label}</Text>
    <DownOutlined className="text-xs mt-1 text-primary-600" />
  </Button>
);
